import mitt from 'mitt'

export const emitter = mitt()

export const RESET_FORM = 'RESET_FORM'

export const dispatchResetForm = () => emitter.emit(RESET_FORM)
